export default "__VITE_ASSET__Djq8$C2c__"